import React from "react";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import style from "./Style.module.css";
import { is_empty } from "features/Common/utils/common.utils";
import { SUBSCRIPTION_PLAN } from "constants/account.constants";
import { openPricingPage } from "utils/Utils";
import LockRoundedIcon from "@material-ui/icons/LockRounded";
import {
  featureCardsDescription,
  featureCardsHeading,
} from "./FeatureCard.constants";
import classnames from "classnames";

const FeatureCard = ({
  featureName,
  desktopImage,
  mobileImage,
  ctaText,
  customLockIcon,
  textConClasses = "",
  headingClasses = "",
  descriptionClasses = "",
  onClick,
}) => {
  const isDesktop = useDesktopMediaQuery();

  return (
    <div className={style.container}>
      <ExlyImage
        src={isDesktop ? desktopImage : mobileImage}
        alt={featureName}
        className={style.cardImage}
      />
      <div className={classnames(style.featureTextContainer, textConClasses)}>
        <div className={style.innerBox}>
          {customLockIcon || <LockRoundedIcon className={style.lockIcon} />}
          <div className={classnames(style.heading, headingClasses)}>
            {featureCardsHeading[featureName]}
          </div>
          <div
            className={classnames(
              style.description,
              `mt-1`,
              descriptionClasses
            )}
          >
            {featureCardsDescription[featureName]}
          </div>
          <div
            className={`${style.upgradeBtn} mt-3`}
            onClick={onClick || openPricingPage}
          >
            {!is_empty(ctaText)
              ? ctaText
              : `Upgrade to ${SUBSCRIPTION_PLAN.PRO}/${SUBSCRIPTION_PLAN.PREMIUM}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
